import moment from 'moment';

export function formatAsDuration(value: number, options: { unit: 'seconds' } = { unit: 'seconds' }) {
  // TODO(mike): Will need fixing. This is incomplete.
  // use `moment-duration-format` or some other formatting.
  const duration = moment.duration(value, options.unit);
  const m = moment.utc(duration.as('milliseconds'));
  return (duration.days() || duration.hours())
    ? m.format('HH:mm:ss')
    : m.format('mm:ss');
}
